module.exports = __webpack_public_path__ + "static/media/Spotifylogo.31bad8d4.png";